import { CountUp } from 'countup.js'

export default async function () {
  const metrics = document.querySelectorAll('[data-waste-metric]')
  if (metrics.length) {
    try {
      const res = await fetch(
        'https://api.bowercollective.com/plastic-waste/metrics-totals',
      )
      const body = await res.json()
      metrics.forEach((el) => {
        const metricLabel = el.getAttribute('data-waste-metric') as
          | 'weight'
          | 'carbon'
          | 'equivalent'
          | 'cleanhub'

        let metricValue = body[metricLabel]
        if (metricLabel === 'weight') {
          metricValue = body[metricLabel] / 1000
        } else if (metricLabel === 'carbon') {
          metricValue = 76
        } else if (metricLabel === 'cleanhub') {
          metricValue = 10000
        } else if (metricLabel === 'equivalent') {
          metricValue = (body.weight + 10000 * 1000) / 14
        }
        new CountUp(el as HTMLElement, metricValue, {
          enableScrollSpy: true,
          scrollSpyOnce: true,
        })
      })
    } catch (e) {
      window.Bugsnag.notify(e as Error)
    }
  }
}
